import { useState } from "react";
import Link from "next/link";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 w-full flex justify-center items-center py-2">
      <div className="flex items-center w-full max-w-5xl px-4">
        {/* Logo Placeholder */}
        <div className="flex-shrink-0 flex items-center mr-4">
          {/* <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-gray-400 to-gray-700 flex items-center justify-center text-white font-bold text-sm shadow-md">
            <span>D</span>
          </div>
          <Link
            href="#"
            className="ml-2 text-base font-bold tracking-tight text-white hover:opacity-80 transition-opacity"
          >
            TnT
          </Link> */}
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden ml-auto p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-white/10 transition-colors"
          aria-label="Toggle menu"
        >
          <div className="w-6 h-5 relative flex flex-col justify-between">
            <span className={`w-full h-0.5 bg-gray-900 dark:bg-white transform transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`w-full h-0.5 bg-gray-900 dark:bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`} />
            <span className={`w-full h-0.5 bg-gray-900 dark:bg-white transform transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </div>
        </button>

        {/* Navigation Links */}
        <div className="flex-1 flex justify-center">
          <div
            className={`md:flex gap-6 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md rounded-xl py-2 px-4 shadow-lg border border-gray-200 dark:border-gray-800 ${
              isMenuOpen
                ? 'fixed top-16 left-4 right-4 flex flex-col items-center gap-4 py-4'
                : 'hidden'
            }`}
          >
            <Link
              href="/"
              className="text-gray-900 dark:text-white text-base font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap text-center w-full"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              href="/#about"
              className="text-gray-900 dark:text-white text-base font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap text-center w-full"
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
            <Link
              href="/#projects"
              className="text-gray-900 dark:text-white text-base font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap text-center w-full"
              onClick={() => setIsMenuOpen(false)}
            >
              Projects
            </Link>
            <Link
              href="/#experience"
              className="text-gray-900 dark:text-white text-base font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap text-center w-full"
              onClick={() => setIsMenuOpen(false)}
            >
              Experience
            </Link>
            <Link
              href="/blog"
              className="text-gray-900 dark:text-white text-base font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap text-center w-full"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              href="/#contact"
              className="text-gray-900 dark:text-white text-base font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors whitespace-nowrap text-center w-full"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
